<template>
  <div>
    <v-container v-if="event !== null">
      <!-- The v-if is there simply so we don't get an error in the console, since it loads the event
      from firebase, which takes longer than vue takes to parse and render the page. We'll use this
      opportunity to display a loading indicator while we're at it. -->
      <h1>{{event.title}} - {{formatDate(event.date)}}</h1>
      <add-position-dialog/>

      <v-form ref="form">
        <v-container>
          <v-flex>
            <div v-if="this.$store.state.positions.length === 0">
              No positions
            </div>
            <div v-else v-for="position in this.$store.state.positions" :key="position.id">
              <!-- I really don't like how I have to have what are essentially the same elements,
                   except for the rules prop. It makes it feel/look really janky. -->
              <v-autocomplete :ref="position.title" v-if="position.required" :id="`position-${position.title}`"
                              v-model="position.member"
                              :items="crewMembers" :label="position.title" :rules="requiredRules"/>

              <v-autocomplete :ref="position.title" v-else :id="`position-${position.title}`"
                              v-model="position.member"
                              :items="crewMembers" :label="position.title"/>
            </div>
          </v-flex>
        </v-container>

        <v-btn @click="createCrewAssignments()">
          <span>submit</span>
          <v-icon right>add</v-icon>
        </v-btn>
      </v-form>
    </v-container>
    <v-container v-else class="text-xs-center">
      <v-progress-circular indeterminate/>
    </v-container>
  </div>
</template>

<script>
import Parse from 'date-fns/parse';
import Format from 'date-fns/format';
import {db} from '../fbConfig';
import AddPositionDialog from '../components/AddPositionDialog.vue';

export default {
  name: 'AddEventAssignments',
  components: {AddPositionDialog},
  data() {
    return {
      event: null,
      assignments: null,
      requiredRules: [
        value => !!value || 'required'
      ]
    };
  },
  methods: {
    formatDate(date) {
      let formattedDate = Parse(date.toDate());
      formattedDate = Format(formattedDate, 'h:mm A, MMM Do YYYY');

      return formattedDate;
    },
    async createCrewAssignments() {
      if (this.$refs.form.validate() === false) {
        return;
      }

      for (const position of this.$store.state.positions) {
        this.assignments[position.title] = position.member;
      }

      console.log(this.assignments);
      console.log(this.event);

      await db.collection('Events').doc(this.$route.params.id).update({assignments: this.assignments});
    }
  },
  computed: {
    crewMembers() {
      const members = [];
      for (const member of this.$store.state.crewMembers) {
        // TODO: Find out if I should handle people that have the same name. As it stands,
        // the vuetify component will remove duplicate entries, so if we do want to support multiple
        // people with the same name, I'll have to rework how I add names to the list a bit.
        if (member.inactive === false) {
          members.push(member.name);
        }
      }

      return members;
    }
  },
  async created() {
    // Make sure crew members are loaded.
    db.collection('CrewMembers')
      .onSnapshot(res => {
        for (const change of res.docChanges()) {
          // TODO: Handle removed/deleted/changed/whatever
          if (change.type === 'added') {
            this.$store.commit('addCrewMember', {
              id: change.doc.id,
              ...change.doc.data()
            });
          }
        }
      });

    this.event = (await db.collection('Events')
      .doc(this.$route.params.id)
      .get()).data();

    this.assignments = {};
  }
};
</script>

<style scoped>

</style>
